import { render, staticRenderFns } from "./FormTimepickerBasic.vue?vue&type=template&id=2228a42f&"
import script from "./FormTimepickerBasic.vue?vue&type=script&lang=js&"
export * from "./FormTimepickerBasic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports